import styles from "./style.module.scss";

import DynamicForm from "@mavichpe/dynamic-forms";
import CancelInvoiceFormConfig from "./form";
import { CancelInvoiceDataType } from "@/formTypes/CancelInvoiceDataType";

type CancelInvoiceFormProps = {
  onCancelInvoice: (data: CancelInvoiceDataType) => void,
  defaultData?: CancelInvoiceDataType,
  innerForm?: boolean,
  onInputChange?: (name: keyof CancelInvoiceDataType, value: unknown) => void,
}

const CancelInvoiceForm = (props: CancelInvoiceFormProps) => {
  const { onCancelInvoice, innerForm = false, defaultData, onInputChange } = props;

  return (
    <>
      <DynamicForm<CancelInvoiceDataType>
        externalFormState={defaultData}
        innerForm={innerForm}
        formConfig={CancelInvoiceFormConfig}
        onSubmit={onCancelInvoice}
        onInputChange={onInputChange}
      >
      </DynamicForm>
    </>

  )
}

export default CancelInvoiceForm;